async function initContacts() {
    if (!document.querySelector('.js-contacts-wrapper')) return;
    documentPreloaderStart();
    const contactsWrapper = document.querySelector('.js-contacts-wrapper');
    if (contactsWrapper.classList.contains('_init')) {
        documentPreloaderEnd();
        return
    }
    const filter = contactsWrapper.querySelector('.js-contacts-filter');
    const list = contactsWrapper.querySelector('.js-contacts-list');
    const map = contactsWrapper.querySelector('.js-contacts-map');

    const config = {
        cities: await getStoresData(),
        filter: 'all',
        listItemHeight: 300,
        list: null,
        map: null,
    }

    initFilter();
   // initList();
    ymaps.ready(initMap);
    contactsWrapper.classList.add('_init');

    function initMap() {
        config.map = new ymaps.Map(map, {
            center: [55.905452, 37.539311],
            controls: [],
            zoom: 10,
        });

        renderPlacemark();
        documentPreloaderEnd();
    }

    function initFilter() {
        let options = '';
        for (let city in config.cities) {
            options += `<option value="${city}">${config.cities[city][0].city}</option>`
        }

        let allCitiesLang = 'Все города';


        switch (window.lang) {
            case 'en':
                allCitiesLang = 'All cities';
                break;
        }

        filter.innerHTML = `
            <select class="contacts__filter-select js-contacts-filter-select base-select">
                <option value="all">${allCitiesLang}</option>
                ${options}
            </select>
        `

        initSelect();
        filter.addEventListener('click', changeFilter)
    }

    function initList() {
        list.innerHTML = `
            <div class="swiper js-list-slider">
                <div class="swiper-wrapper"></div>
                <div class="swiper-button-prev js-list-slider-prev"></div>
                <div class="swiper-button-next js-list-slider-next"></div>
                <div class="swiper-scrollbar js-list-slider-scrollbar"></div>
            </div>
        `

        config.list = list.querySelector('.js-list-slider');

        const listSliderConfig = new Swiper(config.list, {
            slidesPerView: 1,
            spaceBetween: 16,
            scrollbar: {
                el: '.js-list-slider-scrollbar',
                draggable: true,
            },
            on: {
                init: renderList,
            },
            breakpoints: {
                667: {
                    slidesPerView: 2,
                },
                768: {
                    spaceBetween: 24,
                    slidesPerView: 3,
                },
                1024: {
                    spaceBetween: 24,
                    slidesPerView: 4,
                    scrollbar: {
                        enabled: false,
                    },
                    navigation: {
                        nextEl: '.js-list-slider-next',
                        prevEl: '.js-list-slider-prev',
                    },
                }
            }
        })

        config.list.addEventListener('click', selectStore);
    }

    function renderList(swiper) {
        swiper.removeAllSlides();

        for (let [city, data] of Object.entries(config.cities)) {
            if (config.filter === 'all') {
                addListItem(swiper, data);
            } else if (city === config.filter) {
                addListItem(swiper, data);
            }
        }

        dropdownList();
    }

    function dropdownList() {
        const slides = config.list.swiper.slides;

        slides.forEach(item => {
            const itemList = item.querySelector('.js-contacts-list-item');

            if (itemList.offsetHeight > config.listItemHeight) {
                item.style.maxHeight = `${config.listItemHeight}px`;
                item.classList.add('_dropdown');

                item.addEventListener('click', (e) => {
                    const target = e.target.closest('.contacts__list-name');

                    if (!target) return;

                    e.stopPropagation();

                    if (item.classList.contains('_dropdown-active')) {
                        item.classList.remove('_dropdown-active');
                        item.style.maxHeight = `${config.listItemHeight}px`;
                    } else {
                        item.classList.add('_dropdown-active');
                        item.style.maxHeight = `${item.scrollHeight + 1}px`;
                    }
                })
            } else {
                itemList.style.height = '100%';
            }
        })
    }

    function renderPlacemark() {
        config.map.geoObjects.removeAll();
        config.map.geoObjects.each(p => console.log(p))

        const geoObjects = [];

        for (let [city, data] of Object.entries(config.cities)) {
            if (config.filter === 'all') {
                getPlacemarks(data, geoObjects);

                continue;
            }

            if (city === config.filter) {
                getPlacemarks(data, geoObjects);
            }
        }

        const clusterer = new ymaps.Clusterer({
            gridSize: 100,
            clusterIconLayout: getClustererIconLayout(),
        });

        clusterer.add(geoObjects);
        config.map.geoObjects.add(clusterer);

        if (geoObjects.length > 1) {
            config.map.setBounds(config.map.geoObjects.getBounds(), {
                checkZoomRange: true,
                duration: 500,
                timingFunction: 'ease-in-out',
                useMapMargin: true,
                preciseZoom: true,
                zoomMargin: window.innerWidth <= 767 ? 42 : 61
            });
        } else {
            config.map.setCenter(geoObjects[0].geometry.getCoordinates(), 17, {
                checkZoomRange: true,
                duration: 500,
                timingFunction: 'ease-in-out',
                useMapMargin: true,
            });
        }
    }

    function getPlacemarks(data, geoObjects) {
        data.forEach(({coords}) => {
            geoObjects.push(new ymaps.Placemark(coords, {}, {
                iconLayout: getCustomPlacemarkLayout(),
                iconShape: {
                    type: 'Circle',
                    coordinates: [0, 0],
                    radius: window.innerWidth < 768 ? 42 : 61,
                },
            }))
        })
    }

    function getCustomPlacemarkLayout() {
        return ymaps.templateLayoutFactory.createClass(`
            <div class="placemark">
                <div class="placemark__content">
                    <div class="placemark__icon">
                        <svg>
                            <use xlink:href="#map-pin"></use>
                        </svg>
                    </div>
                </div>
            </div>
        `);
    }

    function getClustererIconLayout() {
        return ymaps.templateLayoutFactory.createClass(`
            <div class="placemark">
                <div class="placemark__content">
                    <div class="placemark__icon">
                        <svg>
                            <use xlink:href="#map-pin"></use>
                        </svg>
                    </div>
                    <div class="placemark__count">{{ properties.geoObjects.length }}</div>
                </div>
            </div>
        `);
    }

    function addListItem(swiper, data) {
        data.forEach(({address, coords, email, site, phones, storeName}) => {
            const slide = `
                <div class="swiper-slide" data-coords="${coords}">
                    <div class="contacts__list-item js-contacts-list-item">
                        ${storeName ? `<h3 class="contacts__list-name">${storeName}</h3>` : ''}
                        ${address ? `<span class="contacts__list-address">${address}</span>` : ''}
                        ${email ? `<a href="mailto:${email}" class="contacts__list-site">${email}</a>` : ''}
                        ${site ? `<a href="//${site}" target="_blank" class="contacts__list-site">${site}</a>` : ''}
                        ${phones.length ? `
                            <ul class="contacts__list-phones">
                                ${phones.map(({phone, info}) => (`
                                    <li>
                                        ${phone ? `<a href="tel:${phone.replace(/[-()\s]/ig, '')}" onclick="ym(53957554,'reachGoal','clickPhone');" class="contacts__list-phone">${phone}</a>` : ''}
                                        ${info ? `<div class="contacts__list-phonesInfo">${info}</div>` : ''}
                                    </li>
                                `)).join('')}
                            </ul>
                        ` : ''}
                    </div>
                </div>
            `;

            swiper.appendSlide(slide)
        })
    }

    function selectStore(e) {
        const target = e.target.closest('[data-coords]');

        if (!target) return;

        list.querySelector('[data-coords].active')?.classList.remove('active');
        target.classList.add('active');

        const storeCenter = target.dataset.coords.split(',');

        config.map.setCenter(storeCenter, 17, {
            checkZoomRange: true,
            duration: 500,
            timingFunction: 'ease-in-out',
            useMapMargin: true,
        });

        if (window.innerWidth <= 767) {
            window.scrollTo({
                top: map.offsetTop - window.innerHeight / 2 + map.offsetHeight / 2,
                behavior: 'smooth'
            })
        }
    }

    function changeFilter(e) {
        const target = e.target.closest('[data-value].option:not(.selected)');

        if (!target) return;

        config.filter = target.dataset.value;

        // Список магазинов отключён (initList закомментирован) — фильтруем только метки на карте
        if (config.list) {
            config.list.swiper.virtual.removeAllSlides();
            renderList(config.list.swiper);
        }

        renderPlacemark();
    }
}
